/* global define */

define('paychex.app.messages/panel/module',[
    'angular',
    'jquery',
    'paychex.app.common/services',
    'paychex.app.common/globalFrameUI/module',
    'paychex.app.messages/services/module',
    'paychex.framework.angular.localization/module',
    'paychex.app.messages/panel/Constants',
    'paychex.app.messages/panel/MessageListPanelController',
    'paychex.framework.angular.utils/module',
    'paychex.framework.angular.eventing/module',
    'paychex.framework.angular.ui2/module'
], function (angular,
             jquery,
             CommonServices,
             GlobalFrameUIModule,
             MessageServicesModule,
             pngLocalizationModule,
             Constants,
             MessageListPanelController) {
    'use strict';

    return angular.module('paychex.app.panel.messageList', [
        CommonServices.name,
        GlobalFrameUIModule.name,
        MessageServicesModule.name,
        pngLocalizationModule.name,
        'paychex.framework.angular.utils',
        'paychex.framework.angular.eventing',
        'paychex.framework.angular.ui2'
    ])
        .controller(Constants.messageListPanelControllerName, MessageListPanelController);
});


